import { factory } from '@store/utils'

export default {
  auto: ['actions'],

  store: {
    getters: {
      reviewImportFactory: factory(() => ({
        html: null,
        url: null,
      })),
    },
  },
}
